import { apiCall } from './base';

export const fetchPeriods = () => apiCall(`/periods`, { method: 'GET' });
